<section class="base-wrap-modal">
  <div class="base-modal-header">
    <h2 mat-dialog-title>{{ title | translate:titleParams }}</h2>
  </div>

  <!-- CONTENT -->
  <div class="base-modal-content">
    <ng-content select="[main]"></ng-content>

  </div>

  <!-- FOOTER -->
  <div class="base-modal-footer" *ngIf="hasFooter">

    <ng-content select="[footer]"></ng-content>

    <!-- default -->
    <div>
      <button *ngIf="hasSubmit" mat-flat-button class="m-2" color="primary" (click)="onSubmit()"
        [appTooltip]="'enum.SubmitType.'+submitText | translate" [disabled]="isDisabled || loading">
        <ng-container *ngIf="showLoading && loading; else text">
          <mat-icon>
            <mat-spinner diameter="20">
            </mat-spinner>
          </mat-icon>
        </ng-container>
      </button>
      <button *ngIf="hasCancel" mat-flat-button class="m-2" color="primary" [mat-dialog-close]="defaultCloseValue"
        [disabled]="isCancelDisabled" [appTooltip]="cancelText | translate">{{ cancelText | translate }}</button>
    </div>
  </div>
</section>

<ng-template #text>
  {{ 'enum.SubmitType.'+submitText | translate }}
</ng-template>
